module.exports = __webpack_public_path__ + "static/media/medium-business-square.bb8a144a.jpg";